import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get("token");

    const [password, setPassword] = useState("");
    const [confirmPw, setConfirmPw] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            toast.error("Invalid token link. Redirecting...");
            navigate("/login");
        }
    }, [token, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPw) {
            return toast.error("Passwords do not match");
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Password updated successfully! Please login.");
            navigate("/login");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed to update password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6">
            <div className="tf-card-accent w-full max-w-md p-8 border border-[#27272A]">
                <div className="text-center mb-6">
                    <div className="label-mono text-[#00FF41] mb-2">// credentials update</div>
                    <h2 className="heading-md">RESET PASSWORD</h2>
                </div>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <div className="label-mono mb-1">NEW PASSWORD</div>
                        <div className="flex items-center border-b-2 border-[#27272A] focus-within:border-[#00FF41]">
                            <span className="text-[#52525B] mr-2">{">"}</span>
                            <input 
                                type="password"
                                required
                                minLength={6}
                                className="bg-transparent flex-1 py-2 outline-none font-mono text-[#FAFAFA]" 
                                placeholder="******" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                            />
                        </div>
                    </div>
                    <div>
                        <div className="label-mono mb-1">CONFIRM PASSWORD</div>
                        <div className="flex items-center border-b-2 border-[#27272A] focus-within:border-[#00FF41]">
                            <span className="text-[#52525B] mr-2">{">"}</span>
                            <input 
                                type="password"
                                required
                                minLength={6}
                                className="bg-transparent flex-1 py-2 outline-none font-mono text-[#FAFAFA]" 
                                placeholder="******" 
                                value={confirmPw} 
                                onChange={(e) => setConfirmPw(e.target.value)} 
                            />
                        </div>
                    </div>
                    <button type="submit" disabled={loading} className="tf-btn w-full justify-center">
                        {loading ? "SAVING PASSWORD..." : "UPDATE PASSWORD"}
                    </button>
                </form>
            </div>
        </div>
    );
}
